import { deriveWebPortalAccessFromFeatures } from "./accessControl";

/**
 * @param {Record<string, any>} planDoc — Firestore plansAccess document
 * @returns {Record<string, any>}
 */
export function computeDefaultWebPortalAccess(planDoc) {
  if (!planDoc || typeof planDoc !== "object") {
    return { fullAccess: true };
  }

  const planId = planDoc.planId || "";

  if (planId === "trial_plan") {
    return { fullAccess: true };
  }

  return deriveWebPortalAccessFromFeatures(planDoc.features || {});
}
